// TODO: REFACTORING
import React, { Fragment, cloneElement } from 'react';
import { useTooltip, TooltipPopup } from '@reach/tooltip';
import Portal from '@reach/portal';
import { useTransition, animated } from 'react-spring';
import '@reach/tooltip/styles.css';

animated.TooltipPopup = animated(TooltipPopup);
animated.TooltipContent = animated(TooltipPopup);

function AnimatedTooltip({ children, tooltipStyles = {}, ...rest }) {
  const [trigger, tooltip] = useTooltip();
  const { isVisible, triggerRect } = tooltip;
  const transitions = useTransition(isVisible ? tooltip : false, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { mass: 1, tension: 500, friction: 40 },
  });
  return (
    <Fragment>
      {cloneElement(children, trigger)}
      {transitions.map(
        ({ item: tooltip, props: styles, key }) =>
          tooltip &&
          isVisible && (
            <div key={key}>
              <Portal>
                <animated.div
                  style={{
                    position: 'absolute',
                    left:
                      triggerRect &&
                      triggerRect.left - 10 + triggerRect.width / 2,
                    top: triggerRect && triggerRect.bottom + window.scrollY,
                    width: 0,
                    height: 0,
                    borderLeft: '10px solid transparent',
                    borderRight: '10px solid transparent',
                    borderBottom: '10px solid #009889',
                    zIndex: 9999999,
                    ...styles,
                  }}
                />
              </Portal>
              <animated.TooltipContent
                {...tooltip}
                {...rest}
                style={{
                  background: '#009889',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  padding: '0.5em 1em',
                  fontWeight: 'bold',
                  whiteSpace: 'pre-line',
                  zIndex: 9999999,
                  ...styles,
                  ...tooltipStyles,
                }}
              />
            </div>
          )
      )}
    </Fragment>
  );
}

export default AnimatedTooltip;
